import React,{useRef,useState,useEffect} from 'react'
// import { products } from '../utils/products'
import Product from './Product'
import classes from '../styles/Products.module.scss'
import Sidebar from './Sidebar'
import { useDispatch, useSelector } from 'react-redux'
import { selectToggle} from '../redux/features/sidebarSlice'
import {items} from '../utils/navbarItems'
import {womenCategories,menCategories} from '../utils/filterItems'
import {FiChevronDown} from 'react-icons/fi'
import {BsChevronDown,BsChevronUp} from 'react-icons/bs'
import axios from 'axios'
import {searchForProduct,selectSearch} from '../redux/features/navbarSlice'
import { SpinnerDotted } from 'spinners-react';
import { GrClose } from "react-icons/gr";
import {Navigate, Outlet, useLocation, useNavigate} from 'react-router-dom'
import { Link } from 'react-router-dom'
import {useParams} from 'react-router-dom'
import Layout from './Layout'
import { selectisGenderSwitched, selectProductsData, storeProducts, switchGender } from '../redux/features/productSlice'


const ProductsLayout = (props) => {
    const linksContainerRef = useRef([]);
    const linksRef = useRef([]);
    const [show, setShow] = useState(true)
    const [products, setproducts] = useState([])
    const [filteredProducts, setFilteredProducts] = useState([])
    const [active,setActive] = useState(false)
    const [sortOption, setSortOption] = useState("latest")
    let whatWeAreSearchingFor= useSelector(selectSearch)
    const [openFilters,setOpenfilters]=useState(false)
    const [desktop,setDesktop]=useState(true)
    const [categoryItems,setCategoryItems]=useState([])
    const [category,setCategory]=useState("")
    const location = useLocation()
    let { childCategory } = useParams();
    const navigate = useNavigate();
    let {gender} = useParams()



    const dispatch=useDispatch()
    let productsData= useSelector(selectProductsData)
    let isGenderSwitched = useSelector(selectisGenderSwitched)


    // Read products of a specific category 
    const read = async ()=>{
        const {data}=await axios.get(`${process.env.REACT_APP_BACKEND_URL+"products/readbycategory/"+gender}`)
        setproducts(data)
    }

    
    const [idOfRemovedProduct, setIdOfRemovedProduct] = useState("");
    const [childCat, setChildCat] = useState("");

    // when the admin deletes a product, this remove the product from the list of products
    const handleDataFromChild = (id) => {
        setIdOfRemovedProduct(id);
        //console.log("this is the id of the removed product: "+id)
        setproducts(products.filter(product=> product._id != id))
    }

    const getInStockProducts= async (e)=>{
        
        const url = location.pathname

        const parts = url.split("/");

        // if (parts.length > 3) {
            // const result = "/" + parts.slice(3).join("/");
            // //console.log("there is 3rd route: "+result); // /hoodies
        //}

        if (e.target.checked){
            setActive(true)
            //console.log("checked")
            if (parts.length > 3) {
                const result = parts.slice(3).join("/");
                const {data}=await axios.get(`${process.env.REACT_APP_BACKEND_URL+"products/instock/"}`,
                    {
                        params:{
                            gender: gender,
                            category: result,
                        }
                            
                    },
                )
                setproducts(data)
                dispatch(storeProducts(data))
            }else{
                const {data}=await axios.get(`${process.env.REACT_APP_BACKEND_URL+"products/instock/"}`,
                    {
                        params:{
                            gender: gender,
                        }
                            
                    },
                )
                setproducts(data)
                dispatch(storeProducts(data))
            }
            
        }

        if (!e.target.checked){
            setActive(false)
            const {data}=await axios.get(`${process.env.REACT_APP_BACKEND_URL+"products/readbycategory/"+gender}`)
            setproducts(data)
            dispatch(storeProducts(data))
            //console.log("unchecked")
        }
        
    }

    useEffect(() => {
       
        // if (productsData.length > 0){
        //     setproducts(productsData)
        // }else{
            read()
        //}
        ////console.log("isGenderSwitched: "+isGenderSwitched)

        //console.log("products rendered")
        // if the user is searching for products then display the products he is searching for
        // if (whatWeAreSearchingFor.length>0 && products.length>0){
        //     setFilteredProducts(products.filter(product => product.name.toLowerCase().includes(whatWeAreSearchingFor.toLowerCase())))
        //     //console.log("filtered products: "+filteredProducts)
        //     //console.log("this is whatWeAreSearchingFor: "+whatWeAreSearchingFor)
        // }

        if (gender==="men"){
            setCategoryItems(menCategories)
            setCategory("men")
        }else if (gender==="women"){
            setCategoryItems(womenCategories)
            setCategory("women")
        }


        setChildCat(childCategory)
        //console.log("child category is : "+childCategory)
        //console.log("child category is : "+childCat)
        
        //console.log("category: "+category)
        
    }, [whatWeAreSearchingFor,categoryItems,gender,category])

    const readChildCategory = async (categoryLink,childCat)=>{
        
        navigate(categoryLink)
        //console.log("click function readChildCategory")
        
        // const {data}=await axios.get(`${process.env.REACT_APP_BACKEND_URL+"products/childcategory/"+childCat}`)
        // setproducts(data)
    }


    const toggleItems =(index)=>{
        //console.log('this is the index '+index)
        const linksHeight = linksRef.current[index].getBoundingClientRect().height;
        //console.log(linksHeight)
        setShow(!show)
        
        //console.log('ater setshow'+show)
      
        if (show) {
            //console.log('inside show is true')
            linksContainerRef.current[index].style.height = `${linksHeight}px`;
            //console.log(linksHeight)
        } else {
            //console.log('inside show is false')
            linksContainerRef.current[index].style.height = '0px';
        }
    }

    const selectOption= async(option)=>{
        setSortOption(option)
        //console.log("selected option: "+option)
        if (option === "latest" || option === "oldest"){
            const {data}=await axios.get(`${process.env.REACT_APP_BACKEND_URL+"products/sortbydate"}`,
                {
                    params:{
                        option: option,
                        category: category,
                    }
                    
                },
            )
            setproducts(data)
            dispatch(storeProducts(data))
        }else if (option === "low" || option === "high"){
            //console.log("this is the option selected:",option)
            //console.log("this is the sort option selected:",sortOption)
            const {data}=await axios.get(`${process.env.REACT_APP_BACKEND_URL+"products/sortbyprice/"}`,
                {
                    params:{
                        option: option,
                        category: category,
                    } 
                },
            )
            setproducts(data)
            dispatch(storeProducts(data))
            //console.log("these are the data expected to be displayed:",data)
            //console.log("these are the products that are currently displayed:",products)
        }
    }

    const showFilters = () =>{
        setOpenfilters(true)
    }

    const hideFilters = () => {
        setOpenfilters(false)
    }

    const sortByItems =[
        {value:"low", label:"Price low to high"},
        {value:"high", label:"Price high to low"},
        {value:"latest", label:"The latest"},
        {value:"oldest", label:"The oldest"}
    ]

    return (
    <Layout>
        <div className={classes.container}>
                <div className={classes.filter_menu}>
                    <div className={classes.filters} data-test="show-filters" onClick={()=> showFilters()}>Filters</div>
                    {openFilters && <div onClick={()=> hideFilters()}><GrClose size="1.5rem"/></div>}
                </div>
                <div className={openFilters? classes.container__left+" "+classes.show_filters: classes.container__left+" "+classes.hide_filters}>
                    <div className={classes.filter}>Filter by</div>
                    <div className={classes.m_top}>
                        <input type="checkbox" id="available" data-test="available" name="available" value="available" className={classes.checkbox} onChange={(e)=>getInStockProducts(e)} checked={active}/>
                        <label htmlFor="available">Availability</label>
                    </div>
                    {/* <div className={classes.m_top}>
                        <input type="checkbox" id="novelty" name="novelty" value="novelty" className={classes.checkbox} />
                        <label htmlFor="novelty">Popularity</label>
                    </div> */}
              
                    {categoryItems.map((filterItem,filterIndex)=>(
                    <div key={filterIndex} className={classes.m_top}>
                        <div className={classes.left__filter} onClick={()=>toggleItems(filterIndex)}><div className={classes.filter}>{filterItem.name}</div>{show ?<BsChevronDown />:<BsChevronUp />}</div>
                        <div className={classes.links_container} ref={container => linksContainerRef.current[filterIndex] = container}>
                            <div className={classes.links} ref={link => linksRef.current[filterIndex] = link}>
                                {filterItem.subitems.map((link,index) => {
                                return (
                                    <div key={index} className={classes.subItem}>
                                        <div onClick={()=>readChildCategory("/products"+"/"+category+"/"+link.toLowerCase(),link.toLowerCase())}>{link}</div>
                                    </div>
                                );
                                })}
                            </div>
                        </div>
                    </div>
                    ))}
                    <div className={classes.filter+" "+classes.m_top}>Sort by</div>


                    {sortByItems.map(item => <div className={classes.m_top} key={item.value}>
                            <input type="radio" id={item.value} className={classes.radio} data-test={item.value} name="size" value={item.value} defaultChecked={sortOption===item.value} onChange={e=> selectOption(e.target.value)} />
                            <label htmlFor={item.value}>{item.label}</label>
                        </div>)}
                    
                </div>
            
                <Outlet /> 
               
               
        </div>
      
    </Layout>
    )
}

export default ProductsLayout
